import { DoorGroupFilters } from '@hakimo-ui/hakimo/types';
import { atom } from 'jotai';

export interface State {
  filters: DoorGroupFilters;
  page: number;
  pageSize: number;
}

export const initialState: State = {
  filters: {
    name: { values: [], negative: false },
  },
  page: 1,
  pageSize: 20,
};

export const stateAtom = atom<State>(initialState);
